import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CalculateResult, CalculatorItem, CalculatorOccFormData } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomProductActions } from '../store/actions';
import { StateWithProduct } from '../store/product-state';
import { ProductSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductCalculatorService {
  constructor(private store: Store<StateWithProduct>) {}

  loadCalculators(productCode: string): void {
    this.store.dispatch(new CustomProductActions.LoadCalculators(productCode));
  }

  calculate(calculatorCode: string, productCode: string, formData: CalculatorOccFormData[]): void {
    this.store.dispatch(new CustomProductActions.Calculate({ calculatorCode, productCode, formData }));
  }

  getCalculators(productCode: string): Observable<CalculatorItem[]> {
    return this.store.pipe(select(ProductSelectors.getCalculatorsValue(productCode)));
  }

  getResult(): Observable<CalculateResult> {
    return this.store.pipe(
      select(ProductSelectors.getCalculatorResult),
      map((loaderState: StateUtils.LoaderState<CalculateResult>) => loaderState.value),
    );
  }

  resetResult(): void {
    this.store.dispatch(new CustomProductActions.ResetCalculateResult());
  }
}
